import React from 'react';

function FloatingButton() {
  const handleClick = () => {
    window.open("http://pf.kakao.com/_GCiexb/chat", "_blank");
  };

  return (
    <button
      onClick={handleClick}
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '20px',
        backgroundColor: '#FAE203',
        color: '#000',
        border: 'none',
        borderRadius: '50%',
        width: '62px',
        height: '62px',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.4)',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2px',
        textAlign: 'center',
        zIndex: 100,
      }}
    >
      <img
        src="assets/kakaotalk.png"
        alt="kakao"
        style={{ width: '32px', height: '32px', marginBottom: '1px' }}
      />
      <span style={{ fontSize: '9px', fontWeight: 'bold' }}>신고상담</span>
    </button>
  );
}

export default FloatingButton;
